import React from 'react';

import RoutedLayout from 'components/Layout/RoutedLayout';
import { gql } from '@apollo/client';
import { useQuery } from 'hooks/apollo';
import useCustomer from 'hooks/useCustomer';
import Loading from 'components/Loading';
import Funnel from './Funnel';
import routes from './routes';

const QUERY = gql`
  query($customerId: ID!) {
    funnels(customerId: $customerId) {
      id
      title
      website { id title }
      steps {
        id
      }
    }
  }
`;

const FunnelsRoot = () => {
  const { customer, loading: customerLoading } = useCustomer();
  const { data, loading } = useQuery(QUERY, { variables: { customerId: customer?.id }, skip: !customer });

  if (loading || customerLoading) {
    return <Loading />;
  }

  const funnelRoutes = data?.funnels?.map(funnel => ({
    path: funnel.id,
    label: funnel.title,
    component: Funnel,
  })) || [];

  const dynamicRoutes = [...routes, ...funnelRoutes];

  return (
    <RoutedLayout routes={dynamicRoutes} sidebar />
  );
};

export default FunnelsRoot;
